/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CertificationDocumentPageResponseDto>
>;
export function request(
  params: API.basics.certificationDocument.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
